import  {useEffect} from 'react';
import {getFromHubNew} from "../../actions/networkActions";
import browserHistory from "../../utils/history";

function AllRatingsRedirect() {
    useEffect(() => {
        const fetchConfig = async () => {
            const configResponse = await getFromHubNew(`ratings/config`);
            browserHistory.replace(configResponse.useAnonymousMode ? "/ratings/allinone" : "/userratings/allinone")
        }

        fetchConfig();
    })

    return null;
}

export default AllRatingsRedirect;